import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-sunburst-series-options',
	templateUrl:'./AgSunburstSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgSunburstSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgSunburstSeriesPluginCompPage
{
	mdContent_756 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgSunburstSeriesOptions;
\`\`\``;
}
